module.exports = __webpack_public_path__ + "static/media/shot.0a53b786.png";